export default __webpack_public_path__ + "5ecd02e8c39c3b57f4712ee524837a1b.svg";